import { usePaymentsContext } from '../context/PaymentsContext';

/**
 * Hook to access payments data from centralized context
 * This prevents redundant data fetching across components
 */
export const usePayments = () => {
  return usePaymentsContext();
};
